import { render, staticRenderFns } from "./CellSingleComponent.vue?vue&type=template&id=5e85deec&scoped=true&"
import script from "./CellSingleComponent.vue?vue&type=script&lang=js&"
export * from "./CellSingleComponent.vue?vue&type=script&lang=js&"
import style0 from "./CellSingleComponent.vue?vue&type=style&index=0&id=5e85deec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e85deec",
  null
  
)

export default component.exports